import React from "react"
import CollapsibleCardForm from "./CollapsibleFormCard"
import UserDetailsForm from "./UserDetailsForm"
import {
  initialProfileState, validateAge
} from "./UserDetailsFormConfig"
import {
  populateUserDetailStateWithProfile
} from "./userDetailsUtilities";

const birthdayFields = ['day', 'month', 'year']

const ageErrorMsg = {
  primary: 'Primary profile holder must be 13 or older',
  secondary: 'Profile cannot be created for anyone under 2 years'
}

const UserDetailsCard = ({ ...props }) => (
  <CollapsibleCardForm
    name="Basic Information"
    showCompletion
    defaultExpanded
    {...props}
  >
    <UserDetailsForm {...props} />
  </CollapsibleCardForm>
)

// const MAX_HEIGHT_CM = 271
// const KG_TO_LBS_CONVERSION = 2.20462
// const CM_TO_INCHES_CONSTANT = 0.393701

// Some commented out code here is for future use, when we decide
// to enable support for other units for height and weight.
class ProfileCardWrapper extends React.Component {
  state = { ...initialProfileState }

  componentDidMount() {
    this.populateStateWithProfile()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dirty !== this.props.dirty && !this.props.dirty) {
      this.setState({ ...initialProfileState })
    }
    if (prevProps.selected !== this.props.selected) {
      this.props.setProfileDirty(false)
      this.populateStateWithProfile()
    }
  }

  populateStateWithProfile = () => {
    if (this.props.selected) {
      const newState = populateUserDetailStateWithProfile(this.state, this.props.selected)
      this.setState(newState)
    }
  }

  edit = () => {
    this.setState({ isEditing: true })
    this.props.setProfileDirty(true)
  }

  // This is now a placeholder for when we eventually decide to also
  // support cm.
  processHeight = () => {
    const height = this.state.height.value

    // if (height.feet !== undefined && height.inches !== undefined) {
    //   return { feet: height.feet, inches: height.inches }
    // } else {
    //   const totalHeight = Math.floor(CM_TO_INCHES_CONSTANT * height.cm)
    //   const feet = Math.floor(totalHeight / 12)
    //   const inches = totalHeight % 12
    //   return { feet, inches }
    // }

    return { feet: height.feet, inches: height.inches }
  }

  // This is now a placeholder for when we eventually decide to also
  // support kgs.
  processWeight = () => {

    // if (this.state.weight.unit === "lbs") {
    //   return this.state.weight.value
    // } else {
    //   return Math.floor(this.state.weight.value * KG_TO_LBS_CONVERSION)
    // }

    return this.state.weight.value
  }

  getBirthday = () => {
    let date = {}

    // if birth year edited, get new year value
    // otherwise get existing year value, or calculate from age if none exists

    date.year = this.state.year.edited
    ? this.state.year.value
    : this.props.selected.year ||
      new Date().getFullYear() - this.props.selected.age

    date.month = this.state.month.edited
      ? this.state.month.value
      : this.props.selected.month

    date.day = this.state.day.edited
      ? this.state.day.value
      : this.props.selected.day

    date.age = this.props.selected.age
      ? this.props.selected.age
      : new Date().getFullYear() - date.year

    return date
  }

  save = () => {
    this.setState({ disabled: true })

    // do not submit if is primary profile and is under 13, or if not primary but birthday is under 2
    if (!this.isValidAge()) {
      this.setState({
        birthday: {
          ...this.state.birthday,
          valid: false,
          error: this.props.selected.isself ? ageErrorMsg.primary : ageErrorMsg.secondary
        },
      })

      return
    }

    let { year, month, day, age } = this.getBirthday()
    let height = this.processHeight()
    let weight = this.processWeight()

    const saveAnswers = this.props.selected.isNew
      ? Promise.resolve()
      : this.props.saveProfileAnswers(this.props.selected.id, ["basic_info"])

    const saveDetails = this.props.onSave(
      this.props.selected.id,
      this.state.first.edited
        ? this.state.first.value.trim()
        : this.props.selected.first_name,
      this.state.last.edited
        ? this.state.last.value.trim()
        : this.props.selected.last_name,
      this.state.sex.edited
        ? this.state.sex.value
        : this.props.selected.sex === "m" ? "male" : "female",
      this.props.selected.isself,
      year,
      month,
      day,
      age,
      height.feet,
      height.inches,
      weight,
      this.props.selected.isNew
    )

    return Promise.all([saveAnswers, saveDetails])
      .then(() => this.setState({ isEditing: false, disabled: false }))
      .catch((e) => {
        this.setState({ disabled: false })
        throw e
      })
  }

  cancel = () => {
    this.props.setProfileError("")
    this.props.setProfileDirty(false)
  }

  onChangeInput = field => e => {
    this.props.setProfileError("")
    let val = e.target.value
    let isValid = this.state[field].validate(val)

    this.setState({
      [field]: {
        ...this.state[field],
        value: this.state[field].regex
          ? val.replace(this.state[field].regex, "")
          : val,
        edited: true,
        valid: isValid,
      },
    })
  }

  onFocus = field => e => {
    this.setState({
      [field]: {
        ...this.state[field],
        isActive: true,
        edited: true,
      },
    })
  }

  onBlur = field => e => {
    this.setState({
      [field]: {
        ...this.state[field],
        isActive: false,
      },
    })
  }

  onChangeDropdown = field => value => {
    this.props.setProfileError("")

    // if field being edited is a birthday field, validate min age
    if (birthdayFields.includes(field)) {
      let error = this.props.selected.isself ? ageErrorMsg.primary : ageErrorMsg.secondary
      let isValid = this.isValidAge({...this.getBirthday(), [field]: value})

      this.setState({
        [field]: {
          ...this.state[field],
          value: value,
          edited: true,
          valid: true
        },
        birthday: {
          ...this.state.birthday,
          valid: isValid,
          edited: true,
          error: isValid ? false : error
        }
      })

    } else {
      let isValid = this.state[field].validate(value)
      this.setState({
        [field]: {
          ...this.state[field],
          value: value,
          edited: true,
          valid: isValid,
        },
      })
    }
  }

  onChangeHeight = field => value => {
    // this.props.setProfileError("")
    // // let isValid = this.state[field].validate(value)
    // const height =
    //   field === "cm"
    //     ? {
    //         cm:
    //           value.target.value <= MAX_HEIGHT_CM
    //             ? value.target.value
    //             : this.state.height.value.cm,
    //         feet: undefined,
    //         inches: undefined,
    //       }
    //     : { ...this.state.height.value, cm: undefined, [field]: value.value }

    // this.setState({
    //   height: {
    //     ...this.state.height,
    //     value: height,
    //   },
    // })
    let isValid = this.state.height.validate({...this.state.height.value, [field]: value.value})

    this.setState({
      height: {
        ...this.state.height,
        value: {
          ...this.state.height.value,
          cm: undefined,
          [field]: value.value,
        },
        edited: true,
        valid: isValid,
      },
    })
  }

  // setUnit = (field, value) => () => {
  //   this.setState({
  //     [field]: {
  //       ...this.state[field],
  //       unit: value,
  //     },
  //   })
  // }

  // age is minimum valid age. Defaults to 13 here
  isValidAge = (date=null) => {
    let { day, month, year } = date ? date : this.getBirthday()
    let age = this.props.selected.isself ? 13 : 2

    if (!day || !month || !year) return false

    return validateAge(day, month, year, age)
  }

  setPredispositionAnswer = question => token => {
    this.props.setAnswer("basic_info", token, question)
  }

  isDisabled = () => {
    if (this.state.disabled) return true

    // if no fields have been edited, return false
    // if (!Object.keys(this.state).find(k => this.state[k].edited)) return true

    // if age is invalid, return true
    if (!this.isValidAge()) return true

    return (Object.keys(this.state).some(k => this.state[k].valid === false && this.state[k].edited))
  }

  render() {
    let { selected } = this.props
    let disabled = this.isDisabled()
    let { day, month, year, isEditing } = this.state
    let birthdayNeeded =
      (!selected.day || !selected.month || !selected.year) &&
      (!day.value || !month.value || !year.value)

    return (
      <UserDetailsCard
        {...this.props}
        {...this.state}
        edit={this.edit}
        save={this.save}
        cancel={this.cancel}
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        disabled={disabled}
        dirty={this.props.dirty || isEditing}
        birthdayNeeded={birthdayNeeded}
        onChangeDropdown={this.onChangeDropdown}
        onChangeInput={this.onChangeInput}
        onChangeHeight={this.onChangeHeight}
        setPredispositionAnswer={this.setPredispositionAnswer}
        setUnit={this.setUnit}
      />
    )
  }
}

export { ProfileCardWrapper as default }



// WEBPACK FOOTER //
// ./assets/account/components/UserDetailsCard.js